import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { RootState } from 'app/store';
import { postRegister } from './registerClient';

interface PublicCatalogState {
  status: 'idle' | 'loading' | 'succeeded' | 'failed';
  error: string | null;
  generos: any[];
}

const initialState: PublicCatalogState = {
  status: 'idle',
  error: null,
  generos: [],
};

export const fetchPublicGeneros = createAsyncThunk(
  'publicCatalog/fetchGeneros',
  async (_: void, { rejectWithValue }) => {
    try {
      const { result, message, data } = await postRegister('/generos', {});
      if (result) {
        const items = Array.isArray(data) ? data : data?.items || [];
        return items;
      }
      return rejectWithValue(message || 'No fue posible obtener el catálogo de géneros');
    } catch (error: any) {
      return rejectWithValue(error?.message || 'No fue posible obtener el catálogo de géneros');
    }
  }
);

const publicCatalogSlice = createSlice({
  name: 'publicCatalog',
  initialState,
  reducers: {
    clearPublicCatalogs: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchPublicGeneros.pending, (state) => {
        state.status = 'loading';
        state.error = null;
      })
      .addCase(fetchPublicGeneros.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.generos = action.payload as any[];
      })
      .addCase(fetchPublicGeneros.rejected, (state, action) => {
        state.status = 'failed';
        state.error = (action.payload as string) || 'Error al obtener géneros';
        state.generos = [];
      });
  },
});

export const { clearPublicCatalogs } = publicCatalogSlice.actions;
export const selectPublicGeneros = (state: RootState) => state.publicCatalog.generos;
export const selectPublicCatalogStatus = (state: RootState) => state.publicCatalog.status;

export default publicCatalogSlice.reducer;
